import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSheet } from 'vuetify/lib/components/VSheet';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VSheet,{staticClass:"pb-4"},[(_vm.schedule)?_c(VSheet,_vm._l((_vm.schedule.items),function(item,k){return _c('schedule-item',{key:k,attrs:{"item":item,"item_id":k,"availableDays":_vm.availableDays}})}),1):_vm._e(),_c(VBtn,{staticClass:"mt-4 ml-4",on:{"click":_vm.addItem}},[_vm._v(_vm._s(_vm.$t("scheduleItemsAdd")))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }